import React, { Component } from "react";
import Dropzone from "react-dropzone";
import LocaleStrings from "Languages";

export default class LessonDocumentFilesDrop extends Component {
  constructor(props) {
    super(props);
  }

  onDropFile = (files) => {
    var that = this;
    let file = files[0];

    let reader = new FileReader();
    reader.onloadend = () => {
      var item = reader.result;
      var data = { file: item, filename: file.name.replace(/ /g, "-") };
      that.props.onFileSave(data);
      that.props.onFileChnageLocally(true);
    };
    reader.readAsDataURL(file);
  };

  render() {
    return (
      <div className="pointer">
        <Dropzone
          onDrop={this.onDropFile}
          accept="application/*, image/*"
          multiple={false}
        >
          <div className={`${this.props.className}`}>
            <img
              className="file-icon"
              src="../../style/images/upload_icon1.svg"
              alt=""
            />
            <span>
              <div className="custom-placeholder">
                {
                  LocaleStrings.course_lesson_attachment_form_text_content_document
                }
              </div>
            </span>
          </div>
        </Dropzone>
      </div>
    );
  }
}
